import { union, type InferOutput } from 'valibot'
import actionHandlersList from './actionHandlersList.generated'

export const ActionUnionSchema = union(actionHandlersList.map((v) => v[1]))

export type ActionUnion = InferOutput<typeof ActionUnionSchema>
